import React from 'react';
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from '@mui/material';
import FolderIcon from '@mui/icons-material/Folder';
import { JiraProject } from '../types';

interface JiraProjectsListProps {
  projects: JiraProject[];
  onProjectClick?: (project: JiraProject) => void;
}

const JiraProjectsList: React.FC<JiraProjectsListProps> = ({ projects, onProjectClick }) => {
  if (projects.length === 0) {
    return (
      <Box sx={{ textAlign: 'center', py: 4 }}>
        <Typography variant="body1" color="text.secondary">
          Нет проектов для отображения
        </Typography>
      </Box>
    );
  }

  return (
    <TableContainer
      component={Paper}
      elevation={3}
      sx={{
        height: '100%',
        overflow: 'auto',
        display: 'flex',
        flexDirection: 'column',
        '&::-webkit-scrollbar': {
          width: '8px',
          height: '8px',
        },
        '&::-webkit-scrollbar-track': {
          backgroundColor: '#f1f1f1',
        },
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: '#888',
          borderRadius: '4px',
          '&:hover': {
            backgroundColor: '#555',
          },
        },
      }}
    >
      <Table stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell sx={{ fontWeight: 'bold', width: 60 }}></TableCell>
            <TableCell sx={{ fontWeight: 'bold', minWidth: 150 }}>Ключ проекта</TableCell>
            <TableCell sx={{ fontWeight: 'bold', minWidth: 250 }}>Название</TableCell>
            <TableCell sx={{ fontWeight: 'bold', minWidth: 100 }}>ID</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {projects.map((project) => (
            <TableRow
              key={project.id}
              hover
              sx={{
                cursor: onProjectClick ? 'pointer' : 'default',
                '&:hover': {
                  backgroundColor: 'action.hover',
                },
              }}
              onClick={() => onProjectClick?.(project)}
            >
              <TableCell>
                <FolderIcon color="primary" sx={{ fontSize: 32 }} />
              </TableCell>
              <TableCell>
                <Typography variant="body1" fontWeight={500}>
                  {project.key}
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="body2">{project.name}</Typography>
              </TableCell>
              <TableCell>
                <Typography variant="body2" color="text.secondary">
                  {project.id}
                </Typography>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default JiraProjectsList;
